	export default [
	{
		url:"/generalStates",
		name:"Estado General",
		icon:"home"
	},
	{
		url: "/boxList",
		name: "Lista De AI Boxstreamer",
		icon:"list"
	},
	{
		url: "/registerKey",
		name: "Llave De Registro",
		icon:"vpn_key"
	},
	{
		url: "/userRegister",
		name: "Registro De Usuario",
		icon:"person"
	},
	{
		url: "/vehicleList",
		name: "Lista De Vehículos",
		icon:"drive_eta"
	},
	{
		url: "/generalConfig",
		name: "Configuración General",
		icon:"settings"
	},
	// {
	// 	url: "/alert",
	// 	name: "Alert",
	// 	icon:"tag_faces"
	// },
	// {
	// 	url: "/avatar",
	// 	name: "Avatar",
	// 	icon:"tag_faces"
	// },
	// {
	// 	url: "/breadcrumb",
	// 	name: "Breadcrumb",
	// 	icon:"compare_arrows"
	// },
	// {
	// 	url: "/buttons",
	// 	name: "Buttons",
	// 	icon:"dns"
	// },
	// {
	// 	url: "/cards",
	// 	name: "Cards",
	// 	icon:"credit_card"
	// },
	// {
	// 	url: "/checkbox",
	// 	name: "Checkboxes",
	// 	icon:"all_out"
	// },
	// {
	// 	url: "/collapse",
	// 	name: "Collapse",
	// 	icon:"aspect_ratio"
	// },
	// {
	// 	url: "/dialog",
	// 	name: "Dialog",
	// 	icon:"flip_to_front"
	// },
	// {
	// 	url: "/divider",
	// 	name: "Divider",
	// 	icon:"line_weight"
	// },
	// {
	// 	url: "/dropdown",
	// 	name: "Dropdown",
	// 	icon:"rounded_corner"
	// },
	// {
	// 	url: "/input",
	// 	name: "Input",
	// 	icon:"aspect_ratio"
	// },
	// {
	// 	url: "/list",
	// 	name: "List",
	// 	icon:"subject"
	// },
	// {
	// 	url: "/loading",
	// 	name: "Loading",
	// 	icon:"track_changes"
	// },
	// {
	// 	url: "/navbar",
	// 	name: "Navbar",
	// 	icon:"view_quilt"
	// },
	// {
	// 	url: "/notification",
	// 	name: "Notification",
	// 	icon:"picture_in_picture_alt"
	// },
	// {
	// 	url: "/number-input",
	// 	name: "Number input",
	// 	icon:"swap_calls"
	// },
	// {
	// 	url: "/pagination",
	// 	name: "Pagination",
	// 	icon:"unfold_more"
	// },
	// {
	// 	url: "/popup",
	// 	name: "Popup",
	// 	icon:"vibration"
	// },
	// {
	// 	url: "/progress",
	// 	name: "Progress",
	// 	icon:"sort"
	// },
	// {
	// 	url: "/radio",
	// 	name: "Radio",
	// 	icon:"gps_fixed"
	// },
	// {
	// 	url: "/switch",
	// 	name: "Switch",
	// 	icon:"graphic_eq"
	// },{
	// 	url: "/tabs",
	// 	name: "Tabs",
	// 	icon:"gradient"
	// },{
	// 	url: "/textarea",
	// 	name: "Textarea",
	// 	icon:"crop_landscape"
	// }

]